import uuid from 'react-uuid';
import { Monitor } from '../types';

export const getUuid = (): string => {
  return 'a' + uuid().replace(/-/g, '');
};

export const MONITOR_LOADING_STEP = 12;

export const toOrderedMonitors = (monitors: Monitor[]): Monitor[] => {
  // if no monitor has order, return the monitors sorted by name
  if (!monitors.some((item) => item.monitorPositionInfo?.order !== undefined)) {
    return [...monitors].sort((a, b) => a.name.localeCompare(b.name));
  }

  // separate ordered and unordered monitors
  // sort unordered monitors by name, ordered monitors by order
  // insert ordered monitors into the correct position

  const withOrder = monitors.filter(
    (item) => item.monitorPositionInfo?.order !== undefined,
  );
  const withoutOrder = monitors
    .filter((item) => item.monitorPositionInfo?.order === undefined)
    .sort((a, b) => a.name.localeCompare(b.name));

  withOrder.sort((a, b) => {
    const orderA = a.monitorPositionInfo?.order ?? 0;
    const orderB = b.monitorPositionInfo?.order ?? 0;
    if (orderA !== orderB) return orderA - orderB;
    return 0;
  });

  const result = [...withoutOrder];

  withOrder.forEach((item) => {
    const order = item.monitorPositionInfo?.order ?? 0;
    result.splice(order, 0, item);
  });

  return result;
};
